<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('stundent_club_events')"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus=$event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('stundent_club_events')"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus=$event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="checkPermission('leaveofabsence_excelexport')"
                              @exportExcel="downloadExcel">
                <b-row>
                    <b-col sm="6" xs="12">
                        <b-form-group :label="$t('event_name')">
                            <b-form-input type="number" size="sm"
                                          v-model="datatable.queryParams.filter.event_name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" xs="12">
                        <b-form-group :label="$t('event_type')">
                            <multi-selectbox
                                v-model="datatable.queryParams.filter.event_type"
                                :options="eventTypeOptions"></multi-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import LeaveOfAbsenceService from "@/services/LeaveOfAbsenceService";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import qs from 'qs'
import ApprovalStepService from "@/services/ApprovalStepService";
import CourseService from "@/services/CourseService";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        FacultySelectbox,
        ProgramSelectbox,
        MultiSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('stundent_club_events')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('detail'),
                                class: 'ri-search-eye-line',
                                permission: "leaveofabsence_show",
                                callback: (row) => {
                                    this.$router.push('/student/club/events/' + row.id)
                                }
                            },

                        ]
                    },
                    {
                        label: this.$t('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.$t('club_name'),
                        field: 'club_name',
                        hidden: false,
                    },
                    {
                        label: this.$t('event_name'),
                        field: 'event_name',
                        hidden: false,
                    },
                    {
                        label: this.$t('event_type'),
                        field: 'event_type',
                        hidden: false,
                    },
                    {
                        label: this.$t('event_format'),
                        field: 'event_format',
                        hidden: false,
                    },
                    {
                        label: this.$t('status'),
                        field: 'status',
                        hidden: false,
                    },

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: '-id',
                    page: 1,
                    limit: 20
                }
            },

            eventTypeOptions: []
        }
    },
    created() {
        this.filterSet()
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {

            };
        },
        filterClear() {
            this.filterSet()
            this.datatable.queryParams.page = 1;

            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;

            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            this.datatable.queryParams.filter.fall = this.datatable.queryParams.filter.fall == false || this.datatable.queryParams.filter.fall == null ? null : true
            this.datatable.queryParams.filter.spring = this.datatable.queryParams.filter.spring == false || this.datatable.queryParams.filter.spring == null ? null : true

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return LeaveOfAbsenceService.getAll(config)
                .then((response) => {
                    this.datatable.rows = [
                        {
                            id: "1",
                            club_name: "Yapay Zeka Kulübü",
                            event_name: "Kapadokya Gezisi",
                            event_type: "Gezi",
                            event_format: 'Kurum Dışı',
                            status: "Onaylandı",
                        }
                    ]
                    this.datatable.total = 3
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        downloadExcel() {

        },


    }
};
</script>

